import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';

export const useAPIRegisterApplication = (): any => {
  const { data, put, error, loading, response } = useFetch(
    API_ROUTES.APPLICATIONS,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const registerApplication = (id: string): Promise<any> =>
    put(`/${id}/register`);

  return {
    data: data?.data || data,
    loading,
    error,
    loaded: response.ok,
    registerApplication,
  };
};
